import {Link} from 'react-router-dom'
import {FaTwitter,FaGithub, FaLinkedinIn} from 'react-icons/fa'
import { BsChevronBarUp} from "react-icons/bs"
import '../modules/Footer.css'
import '../modules/Global.module.css'
import ScrollToTop from 'react-scroll-to-top'

const Footer = () =>{
    const today = new Date().getUTCFullYear();
    
    return (
        <>
            <section className="page-section" name="contact">
                <div className="TestimonialWrapper__CurveWrapper TestimonialWrapper__TopCurveWrapper">
                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1440 320" transform="scale(1)" translatey={'2px'}
                    className="TestimonialWrappercurves__Svg">
                        <path fillOpacity={1} d="M0,160L48,176C96,192,192,224,288,208C384,192,480,128,576,133.3C672,139,768,213,864,202.7C960,192,1056,96,1152,74.7C1248,53,1344,107,1392,133.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                    </svg>
                </div>
                <div className="TestimonialWrapper__Backdrop">
                    <div className="container">
                    <div className="sec-title centered">
                        <h2>Contact me</h2> 
                    </div>
                        <div className="Footer__SubContainer">
                            <div className="Footer__TextContent">
                                <h2 className="Heading">Let's Build Something Together</h2>
                                    <p className="Paragraph-sc-1tzuhix-0 Footer__SubParagraph">Feel free to reach out if you're looking for a developer, have a question, or just want to connect.</p>
                                        <a href="mailto: ronewamavhungu@gmail.com">
                                            <div className="ContactEmail">ronewamavhungu@gmail.com</div>
                                        </a>
                            </div>
                        </div>
                            <div className="row mt-4"></div>
                    </div>
                </div>
            </section>
            <section className="copyright py-4 text-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <small className='Paragraph-sc-1tzuhix-0'>Copyright &copy; {today} All Rights Reserved By <Link to="#!" style={{color:"white"}} className="Paragraph-sc-1tzuhix-0">Mavhungu Ronewa</Link>
                            </small>
                        </div>
                        <div className="col-lg-4">
                            <ul className="ul-social-circle text-center">
                                <li><a href="https://za.linkedin.com/in/mavhungu-ronewa-8687b7103" target="_blank" rel='noreferrer' text="mavhungu"><span>{<FaLinkedinIn />}</span></a></li>
                                <li><a href="https://twitter.com/MavhunguRgb" target="_blank" rel='noreferrer' text="mavhungu"><span><FaTwitter /></span></a></li>
                                <li><a href="https://github.com/mavhungu" target="_blank" rel='noreferrer' text="mavhungu"><span>{<FaGithub />}</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <div className="scroll-to-top d-lg-none position-fixed ">
                <a className="d-block text-center text-white rounded" href="#page-top" rel='noreferrer'>
                    <i className="bx bxs-chevrons-up"></i>
                    {<BsChevronBarUp />}
                </a>
                <ScrollToTop smooth />
            </div>
        </>
    )
}
export default Footer;